import { classifyError } from '../../utils/errorCodes';

/**
 * Extract a short, user-showable string from any error the renderer sees.
 *
 * Handles the shapes IPC produces:
 *   { error: string }                        — auth/djpal handlers (legacy)
 *   { error: { code, message, requestId } }  — library handlers (structured)
 *   Error thrown across ipcRenderer.invoke   — Electron wraps the message as
 *     "Error invoking remote method 'domain:action': Error: <original>"
 *
 * Delegates to classifyError (utils/errorCodes.js): known-ugly errors (5xx,
 * expired tokens, network failures…) come back as friendly copy with an
 * "(ERROR_CODE)" suffix; everything else is the original message cleaned up
 * (IPC wrapper stripped, tracebacks collapsed, length-capped).
 *
 * Use this before any dispatch(setError(...)) or toast.error(...) so UI
 * components always receive a short plain string, never [object Object],
 * a raw command line, or a stack trace. When the error is being SHOWN to the
 * user and you know the surface, prefer presentError() — same string, but it
 * also ships the code to the error-reporting-service.
 */
export const errMsg = (e) => classifyError(e).display;
